<template>
  <div class="tabs__item item_6">
    <div class="tab__content">
      <div class="tab__content__title">
        <p class="tab__content__title_large">{{ $t("premiumTab.bigHeading") }}</p>
      </div>
      <div class="tab__content__active">
        <div class="tab__content__list">
          <p class="tab__content__list-item"><span class="check-mark"></span>{{ $t("premiumTab.listItemText_1") }}</p>
          <p class="tab__content__list-item"><span class="check-mark"></span>{{ $t("premiumTab.listItemText_2") }}</p>
          <p class="tab__content__list-item"><span class="check-mark"></span>{{ $t("premiumTab.listItemText_3") }}</p>
          <p class="tab__content__list-item"><span class="check-mark"></span>{{ $t("premiumTab.listItemText_4") }}</p>
          <p class="tab__content__list-item"><span class="check-mark"></span>{{ $t("premiumTab.listItemText_5") }}</p>
        </div>
        <div class="tab__content__image-banner">
          <img src="../assets/img/mobile-mockup.png" />
        </div>
        <v-btn depressed
          color="#0cdbf6" class="button_blue button_big connect__btn clickme"
          v-on:click="upgrade" id="upgrade_btn">
          {{ $t('premiumTab.buttonUpgrade') }}
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'tabPremium',
  props: ['loggedIn', 'pivotId', 'instanceId', 'userData'],
  methods: {
    upgrade () {
      this.$emit('upgrade', true)
    }
  },
  mounted () {
    this.$emit('mounted', true)
  }
}
</script>
